import type { AxiosError } from 'axios'

import { toast } from '@utils/functions/notificationToast'
import * as apiConsolidatedEntry from '@services/api/consolidatedEntry'

import { useConsolidatedEntry } from '.'

import type {
  GetPreviaSemanalRequestProps,
  LiberarPreviaSemanalRequestProps,
  SubmitPreviaSemanalRequestProps
} from '@services/api/consolidatedEntry/types'

const getPreviaSemanal = async (payload: GetPreviaSemanalRequestProps) => {
  const { setConsolidatedData, setIsConsolidatedDataLoading } = useConsolidatedEntry.getState()

  setIsConsolidatedDataLoading(true)

  try {
    const data = await apiConsolidatedEntry.getPreviaSemanal(payload)

    setConsolidatedData(data)
  } catch (error) {
    toast.error('Falha ao buscar os dados da prévia semanal!', (error as AxiosError)?.status)
  } finally {
    setIsConsolidatedDataLoading(false)
  }
}

const submitPreviaSemanal = async (payload: SubmitPreviaSemanalRequestProps) => {
  const { setConsolidatedData, setIsSubmitLoading } = useConsolidatedEntry.getState()

  setIsSubmitLoading(true)

  try {
    const data = await apiConsolidatedEntry.submitPreviaSemanal(payload)

    setConsolidatedData(data)
    toast.success('Valores inseridos com sucesso!')

    return true
  } catch (error) {
    toast.error('Não foi possível inserir os valores. Tente novamente', (error as AxiosError)?.status)

    return false
  } finally {
    setIsSubmitLoading(false)
  }
}

const liberarPreviaSemanal = async (payload: LiberarPreviaSemanalRequestProps) => {
  const { setConsolidatedData, setIsLiberarPreviaSemanalLoading } = useConsolidatedEntry.getState()

  setIsLiberarPreviaSemanalLoading(true)

  try {
    const data = await apiConsolidatedEntry.liberarPreviaSemanal(payload)

    setConsolidatedData(data)
    toast.success('Prévia liberada com sucesso!')

    return true
  } catch (error) {
    toast.error('Não foi possível liberar a prévia. Tente novamente', (error as AxiosError)?.status)

    return false
  } finally {
    setIsLiberarPreviaSemanalLoading(false)
  }
}

export { getPreviaSemanal, submitPreviaSemanal, liberarPreviaSemanal }
